export const REFRESH_DOCUMENT_STATE = 'REFRESH_DOCUMENT_STATE';

export const refreshDocumentState = () => ({
    type: REFRESH_DOCUMENT_STATE,
});
